import React from "react";
import AuctionTypesHeader from "./AuctionTypesSection/AuctionTypesHeader";
import AuctionTypeCard from "./AuctionTypesSection/AuctionTypeCard";
import { Clock, Users, Zap, Calendar } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const AuctionTypesSection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData = labels.menuPages?.buyCar?.auctionTypesSection || {};
  const auctionTypesData = sectionData.auctionTypes || [];

  const icons = [
    <Zap className="w-8 h-8" />,
    <Calendar className="w-8 h-8" />,
    <Clock className="w-8 h-8" />,
    <Users className="w-8 h-8" />,
  ];
  const colors = [
    "from-red-500 to-pink-500",
    "from-blue-500 to-cyan-500",
    "from-green-500 to-emerald-500",
    "from-purple-500 to-indigo-500",
  ];
  const gradients = [
    "bg-gradient-to-br from-red-50 to-pink-50",
    "bg-gradient-to-br from-blue-50 to-cyan-50",
    "bg-gradient-to-br from-green-50 to-emerald-50",
    "bg-gradient-to-br from-purple-50 to-indigo-50",
  ];
  const glowColors = [
    "shadow-red-500/30",
    "shadow-blue-500/30",
    "shadow-green-500/30",
    "shadow-purple-500/30",
  ];

  const auctionTypes = auctionTypesData.map((auction: any, index: number) => ({
    icon: icons[index] || icons[0],
    title: auction.title || "",
    duration: auction.duration || "",
    description: auction.description || "",
    features: auction.features || [],
    color: colors[index] || colors[0],
    gradient: gradients[index] || gradients[0],
    glowColor: glowColors[index] || glowColors[0],
  }));

  return (
    <section className="py-10 md:py-12 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <AuctionTypesHeader />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {auctionTypes.map((auction, index) => (
            <AuctionTypeCard key={index} auction={auction} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AuctionTypesSection;
